export {default as BackgroundImage} from './backgroundImage'
export { default as InlineImage } from './inlineImage'



// WEBPACK FOOTER //
// ./src/core/image/index.js